import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidPermissionsPipe } from './validPermissions.pipe';
import { HasPermissionsPipe } from './hasPermissions.pipe';
import { NgxPermissionsModule } from 'ngx-permissions';



@NgModule({
  declarations: [
      ValidPermissionsPipe,
      HasPermissionsPipe
   ],
  imports: [
    CommonModule,
    NgxPermissionsModule
  ],
  exports:[
    ValidPermissionsPipe,
    HasPermissionsPipe
  ]
})
export class ValidPermissionsModule { }
